/**
 * Predefined color options for player cards in TeamScout
 */

export const PLAYER_CARD_COLORS = [
  { name: "Blue", hex: "#2196f3" },
  { name: "Red", hex: "#f44336" },
  { name: "Green", hex: "#4caf50" },
  { name: "Orange", hex: "#ff9800" },
  { name: "Purple", hex: "#9c27b0" },
  { name: "Teal", hex: "#009688" },
  { name: "Pink", hex: "#e91e63" },
  { name: "Amber", hex: "#ffc107" },
  { name: "Indigo", hex: "#3f51b5" },
  { name: "Gray", hex: "#9e9e9e" }
];

/**
 * Get a color from the predefined list or return a default color
 * @param {string} colorHex - Hex color code to find in the predefined list
 * @returns {string} - Matching predefined color or default blue color
 */
export const getClosestPredefinedColor = (colorHex) => {
  if (!colorHex) return PLAYER_CARD_COLORS[0].hex; // Default to blue
  
  // If the color is already in our predefined list, return it
  const matchingColor = PLAYER_CARD_COLORS.find(color => color.hex.toLowerCase() === colorHex.toLowerCase());
  if (matchingColor) return matchingColor.hex;
  
  // Otherwise return default blue
  return PLAYER_CARD_COLORS[0].hex;
};
